<template>
  <v-sheet
    color="authsidebar-bg primary darken4 secondary--text text-h4 text-center font-weight-medium background--primary px-8 d-none d-md-flex align-center justify-center"
    height="100%"
  >
    <p class="sidebar--text">
      Sistema de<br />Gestão<br />
      Adminstrativa
    </p>
  </v-sheet>
</template>

<script>
export default {};
</script>

<style scoped>
.authsidebar-bg {
  background: url('#') no-repeat;
  background-position: center;
  background-size: cover;
}
</style>
